/**
 * Created by piotr.pozniak@thebeaverhead.com on 06/08/2021.
 */
import { GoogleIntegrationHelp } from "./googleIntegrationHelp";
import appConfig from "../../../appConfig";

export const IntegrationStatus = {
  notSynced: -1,
  synced: 0,
  syncInProgress: 1,
  syncError: 2,
  reAuthRequired: 3,
  permissionsRevoked: 4,
};

export const AvailableIntegrations = [
  {
    title: "Google Calendar™",
    type: "google",
    available: true,
    premium: false,
    description: `The ${appConfig.displayName} - Google Calendar integration automatically displays your meetings and events in a variety of views on unlimited calendars.`,
    help: GoogleIntegrationHelp(),
    beforeSyncAlert: null,
    icon: "gcal.png",
  },
  {
    title: "Outlook Calendar™",
    type: "outlook",
    available: true,
    premium: false,
    description: `The ${appConfig.displayName} - Outlook Calendar integration automatically displays your meetings and events in a variety of views on unlimited calendars.`,
    help: GoogleIntegrationHelp(),
    beforeSyncAlert: null,
    icon: "outlook.png",
    beta: true,
  },
].filter((integration) => appConfig.integrations.includes(integration.type));

/**
 *
 * @param status
 * @returns {string}
 */
/**
 * "Healthy" for the calendar-select's connection-status dot (design handoff
 * README §4) — anything other than a clean sync counts as not-healthy,
 * whether that's an error, a pending re-auth, or just not synced yet.
 * @param {{status:number}=} integration
 * @returns {boolean}
 */
export const isIntegrationHealthy = (integration) =>
  integration?.status === IntegrationStatus.synced;

export const getIntegrationStatusLabel = (status) => {
  switch (status * 1) {
    case -1:
      return "Not synced yet";

    case 0:
      return "Synced";

    case 1:
      return "Sync in progress...";

    case 2:
      return "Error";

    case 3:
      return "Re-authorisation required";
  }

  return "Unknown";
};
